import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Col,
} from 'reactstrap';
import { getStateCodes } from '../actions/ProposalsEditor';
import Location from '../components/Location/index';
import SpinnerCircles from './Spinner/SpinerCircles';
import './addressValidation.css';
const E911AddressModal = ({
  isOpen,
  onCancel,
  data,
  onUpdate,
  selectedNumberTitle,
  onRemoveAddress,
  port,
  openValidationModal,
  modalCloseValidation,
  suggestedData,
  isReadOnly,
  zIndex = 1050,
  backdrop = true,
  originalAddress,
  loading,
}) => {
  const [state, setState] = useState(data);
  const [locationState, setLocationState] = useState({});
  const [tempAddress, setTempAddress] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (originalAddress && Object.keys(originalAddress).length) {
      setTempAddress(originalAddress);
    }
  }, [originalAddress, openValidationModal]);

  const formatAddressLines = address => {
    if (!address) return [];
    const address1 = `${address.address1 || address.address || ''}`.trim();
    const address2 = `${address.address2 || ''}`.trim();
    const city = `${address.city || ''}`.trim();
    const stateVal = `${address.state || ''}`.trim();
    const zip = `${address.zip || ''}`.trim();
    const country = `${address.country || ''}`.trim();
    const street = [address1, address2].filter(Boolean).join(', ');
    const cityLine = [city, [stateVal, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
    return [street, cityLine, country].filter(Boolean);
  };

  const originalForDisplay = originalAddress && Object.keys(originalAddress).length
    ? originalAddress
    : tempAddress;

  const dataSuggested = {
    callername: originalForDisplay?.callername || tempAddress?.callername || '',
    dn: originalForDisplay?.dn || tempAddress?.dn || selectedNumberTitle || '',
    address1: suggestedData?.address1 || suggestedData?.AddressLine1 || '',
    address2:
      suggestedData?.address2 ||
      suggestedData?.AddressLine2 ||
      '',
    city: suggestedData?.city || suggestedData?.City || '',
    state: suggestedData?.state || suggestedData?.StateCode || '',
    zip: suggestedData?.zip || suggestedData?.Zip || '',
    country: suggestedData?.country || '',
  };

  const handleChange = e => {
    setState({ ...state, [e.currentTarget.name]: e.currentTarget.value });
  };

  useEffect(() => {
    dispatch(getStateCodes(localStorage.getItem('jwtToken')));
  }, []);

  const removeButton = (
    <Button color="primary" onClick={onRemoveAddress} disabled={loading}>
      {loading ? <SpinnerCircles /> : 'Remove Address'}
    </Button>
  );

  const getLocationInfo = ev => {
    if (ev) {
      setLocationState({
        address1: ev?.address,
        address2: ev?.address2,
        city: ev?.city,
        state: ev?.state,
        zip: ev?.zip,
        country: ev?.country,
      });
    }
  };
  return (
    <>
    <Modal isOpen={isOpen} zIndex={zIndex} backdrop={backdrop} keyboard={backdrop !== 'static'}>
      <ModalHeader close={port?.e911Enabled && removeButton}>{selectedNumberTitle}</ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Label for="callername" sm={4}>
            Caller Name:
          </Label>
          <Col sm={12}>
            <Input
              required
              type="text"
              name="callername"
              placeholder="Caller Name..."
              defaultValue={data?.callername}
              onChange={handleChange}
            />
          </Col>
        </FormGroup>
        <Location
            disabled={false}
            boxDbLocation={data}
            getLocationInfo={getLocationInfo}
            latLang={false}
            address2={true}
        />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={isReadOnly || loading}
          onClick={() => {
            const obj = { ...(data || {}), ...(state || {}), ...locationState };
            obj.address1 = obj.address1 || obj.address || '';
            obj['dn'] = selectedNumberTitle;
            onUpdate(obj);
            setTempAddress(obj)
          }}
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>

      <Modal
        isOpen={openValidationModal}
        centered
        modalClassName="address-validation-modal"
        zIndex={zIndex + 10}
      >
        <ModalHeader className="border-0 flex-column align-items-start">
          <div className="av-number-left">{tempAddress?.dn}</div>
          <div className="w-100 text-center">
            <h2 className="av-title-center">ADDRESS VALIDATION</h2>
          </div>
        </ModalHeader>
        <div className="av-divider" />
        <ModalBody className="text-center">
          <div className="av-address-block">
            <h5 className="av-subtitle">ORIGINAL ADDRESS</h5>
            <p>
              {formatAddressLines(originalForDisplay).map((line, index, arr) => (
                <span key={`original-${index}`}>
                  {line}
                  {index < arr.length - 1 ? <br /> : null}
                </span>
              ))}
            </p>
          </div>
          <div className="av-address-block">
            <h5 className="av-subtitle">SUGGESTED ADDRESS</h5>
            <p>
              {formatAddressLines({
                address1: suggestedData?.address1 || suggestedData?.AddressLine1,
                address2: suggestedData?.address2 || suggestedData?.AddressLine2,
                city: suggestedData?.city || suggestedData?.City,
                state: suggestedData?.state || suggestedData?.StateCode,
                zip: suggestedData?.zip || suggestedData?.Zip,
                country: suggestedData?.country,
              }).map((line, index, arr) => (
                <span key={`suggested-${index}`}>
                  {line}
                  {index < arr.length - 1 ? <br /> : null}
                </span>
              ))}
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex flex-column align-items-center">
          <Button color="primary" onClick={()=>onUpdate(dataSuggested,true)}>
          USE SUGGESTED
        </Button>
          <Button outline color="secondary" onClick={modalCloseValidation}>
          Cancel
        </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default E911AddressModal;
